import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

export const Temperature_Modal = () => {

    const [modal_standard, setmodal_standard] = useState(false);
    function tog_standard() {
        setmodal_standard(!modal_standard);
    }

  return (
    <>
         <span color="secondary" onClick={() => tog_standard()} style={{ backgroundColor: 'transparent', border: 'none', padding: '0px', fontSize: '18px', cursor: 'pointer'}}><i className="ri-information-line"></i></span>
      
       {/* Default Modal */}
       <Modal id="myModal"
                isOpen={modal_standard}
                toggle={() => {
                    tog_standard();
                }}
            >
                <ModalHeader className="modal-title"
                    id="myModalLabel" toggle={() => {
                        tog_standard();
                    }}>
                        Temperature
                </ModalHeader>
                <ModalBody>
                    <h5 className="fs-15">
                    number or null
                    </h5>
                    <p className="text-muted">Optional</p>
                    <p className="text-muted">Defaults to 1</p>
                    <p className="text-muted">What sampling temperature to use, between 0 and 2. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic.</p>
                </ModalBody>
                
            </Modal>
    </>
  )
}
